module.exports = __webpack_public_path__ + "static/media/desafio-decreditos1.d3fcbce1.png";